var MenuProductEntities = require('../../admin-app/entities/menu-product-base');
var EntitiesBase = require('../../entities/base');
var LocationEntities = require('../../entities/location');
var StrainGroupEntities = require('../../admin-app/entities/strain-group');
var ProductVendorEntities = require('../../admin-app/entities/product-vendor');
var VariantsCollection = Backbone.Collection.extend({
    constructor: function(models, options) {
        Backbone.Collection.prototype.constructor.call(this, models, options);
    },
    comparator: function (variant1, variant2) {
      var variant1Price = !isNaN(variant1.get('price')) ?  parseFloat(variant1.get('price')) : 0;
      var variant2Price = !isNaN(variant2.get('price')) ?  parseFloat(variant2.get('price')) : 0;
      if (variant1Price < variant2Price) {
          return -1;
      } else if (variant2Price < variant1Price) {
          return 1;
      }
    }
});
var PRODUCT_IMAGE_SIZES = {
    THUMB: 'thumb',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge'
};

var MenuProductModel = MenuProductEntities.MenuProductModel.extend({
    PRODUCT_IMAGE_SIZES: PRODUCT_IMAGE_SIZES,
    constructor: function(attrs, options) {
        this.productCategories = options.productCategories;
        this.locationId = options.locationId;
        MenuProductEntities.MenuProductModel.prototype.constructor.call(this, attrs, options);
    },
    nestedEntities: {
        categories: Backbone.Collection,
        locations: Backbone.Collection,
        variants: VariantsCollection,
        images: Backbone.Collection,
        videos: Backbone.Collection,
        strain_group: StrainGroupEntities.StrainGroupModel,
        vendor: ProductVendorEntities.ProductVendorModel
    },
    setNestedEntityClass: function (entityKey, entityData) {
        var self = this;
        var entity = self.get(entityKey);
        switch (entityKey) {
            case 'categories':
            case 'locations':
            case 'images':
                entity.reset(entityData);
                break;
            case 'videos':
                entity.reset(entityData);
                break;
            case 'variants':
                entity.reset(entityData);
                break;
            case 'strain_group':
            case 'vendor':
                entity.set(entity.parse(entityData || {}));
                break;
        }
        return entityData;
    },
    createNestedEntityClass: function (entityKey, entityData) {
        var self = this;
        switch (entityKey) {
            case 'categories':
            case 'locations':
            case 'images':
                return new Backbone.Collection(
                    entityData
                );
            case 'videos':
                return new Backbone.Collection(
                    entityData
                );
            case 'variants':
            case 'strain_group':
            case 'vendor':
                return new this.nestedEntities[entityKey](entityData);
        }
        return entityData;
    },
    parse: function (productAttrs) {
        var self = this;

        productAttrs.priceGram = null;
        productAttrs.priceGramSale = null;
        productAttrs.priceTankHalfGram = null;
        productAttrs.priceTankHalfGramSale = null;
        productAttrs.priceTankGram = null;
        productAttrs.priceTankGramSale = null;
        productAttrs.priceEighth = null;
        productAttrs.priceEighthSale = null;
        productAttrs.priceQuarter = null;
        productAttrs.priceQuarterSale = null;
        productAttrs.priceOunce = null;
        productAttrs.priceOunceSale = null;
        productAttrs.priceHalf = null;
        productAttrs.priceHalfSale = null;
        productAttrs.lowTHC = null;
        productAttrs.highTHC = null;

        if (productAttrs.variants) {

            var variantSalePriceMin = null;
            var variantSalePriceMax = null;
            var variantRegularPriceMin = null;
            var variantRegularPriceMax = null;

            _.each(productAttrs.variants, function(variationAttrs) {
                // Set the item id so that the variation has access to it.
                variationAttrs.itemId = productAttrs.id;
                var variationInStockAtLocation = true;
                if (self.locationId) {
                  _.each(variationAttrs.locations, function(location) {
                    if (self.locationId == location.location_id) {
                      if (location.quantity <= 0) {
                        variationInStockAtLocation = false;
                      }
                    }
                  });
                }

                if (variationInStockAtLocation) {
                  if (variationAttrs.on_sale) {
                    var variantSalePrice = parseFloat(variationAttrs.sale_price);

                    if (variantSalePriceMax == null && variantSalePrice) {
                      variantSalePriceMax = variantSalePrice;
                    }
                    if (variantSalePrice > variantSalePriceMax) {
                      variantSalePriceMax = variantSalePrice;
                    }

                    if (variantSalePriceMin == null && variantSalePrice) {
                      variantSalePriceMin = variantSalePrice;
                    }
                    if (variantSalePrice < variantSalePriceMin) {
                      variantSalePriceMin = variantSalePrice;
                    }
                  }
                  var variantRegularPrice = parseFloat(variationAttrs.price);

                  if (variantRegularPriceMax == null && variantRegularPrice) {
                    variantRegularPriceMax = variantRegularPrice;
                  }
                  if (variantRegularPrice > variantRegularPriceMax) {
                    variantRegularPriceMax = variantRegularPrice;
                  }

                  if (variantRegularPriceMin == null && variantRegularPrice) {
                    variantRegularPriceMin = variantRegularPrice;
                  }
                  if (variantRegularPrice < variantRegularPriceMin) {
                    variantRegularPriceMin = variantRegularPrice;
                  }

                  // any cats that rely on the variation being in stock...
                  if (productAttrs.categories) {
                    variationAttrs.isPreRoll = false;
                    variationAttrs.is510Vaping = false;
                    variationAttrs.isEraVaping = false;
                    variationAttrs.isDosistVaping = false;
                    variationAttrs.isCo2Vaping = false;
                    variationAttrs.isHoneyOilVaping = false;
                    variationAttrs.isDistilliteVaping = false;
                    variationAttrs.isDisposableVaping = false;
                    variationAttrs.isLiveResinVaping = false;
                    variationAttrs.isSativaVaping = false;
                    variationAttrs.isIndicaVaping = false;
                    variationAttrs.isHybridVaping = false;
                    variationAttrs.isTankHalfGram = false;
                    variationAttrs.isTankGram = false;
                    variationAttrs.isEdiblesBaked = false;
                    variationAttrs.isEdiblesBeverages = false;
                    variationAttrs.isEdiblesCooking = false;
                    variationAttrs.isEdiblesCandy = false;
                    variationAttrs.isEdiblesChocolate = false;
                    variationAttrs.preRollSingle = false;
                    variationAttrs.preRollInfused = false;
                    variationAttrs.preRollBlunt = false;
                    variationAttrs.preRollMultiPack = false;
                    variationAttrs.preRollMultiPackQty2 = false;
                    variationAttrs.preRollMultiPackQty3 = false;
                    variationAttrs.preRollMultiPackQty4 = false;
                    variationAttrs.preRollMultiPackQty5 = false;
                    variationAttrs.preRollMultiPackQty10 = false;
                    variationAttrs.preRollGram = false;
                    variationAttrs.preRollHalfGram = false;
                    variationAttrs.preRollSativa = false;
                    variationAttrs.preRollIndica = false;
                    variationAttrs.preRollHybrid = false;
                    _.each(variationAttrs.categories, function(variationCategoryAttrs) {
                        var catModel = self.productCategories.findWhere({
                            slug: variationCategoryAttrs.slug
                        });

                        if (catModel && (catModel.get('slug') == 'flower-1g')) {
                          productAttrs.hasGram = true;
                          productAttrs.priceGram = parseFloat(variationAttrs.price);
                          if (variationAttrs.on_sale) {
                            productAttrs.priceGramSale = parseFloat(variationAttrs.sale_price);
                          }
                        }

                        if (catModel && (catModel.get('slug') == 'flower-3-5g')) {
                          productAttrs.hasEighth = true;
                          productAttrs.priceEighth = parseFloat(variationAttrs.price);
                          if (variationAttrs.on_sale) {
                            productAttrs.priceEighthSale = parseFloat(variationAttrs.sale_price);
                          }
                        }

                        if (catModel && (catModel.get('slug') == 'flowers-7g')) {
                          productAttrs.hasQuarter = true;
                          productAttrs.priceQuarter = parseFloat(variationAttrs.price);
                          if (variationAttrs.on_sale) {
                            productAttrs.priceQuarterSale = parseFloat(variationAttrs.sale_price);
                          }
                        }

                        if (catModel && (catModel.get('slug') == 'flowers-half-ounce')) {
                          productAttrs.hasHalf = true;
                          productAttrs.priceHalf = parseFloat(variationAttrs.price);
                          if (variationAttrs.on_sale) {
                            productAttrs.priceHalfSale = parseFloat(variationAttrs.sale_price);
                          }
                        }

                        if (catModel && (catModel.get('slug') == 'flower-ounce')) {
                          productAttrs.hasOunce = true;
                          productAttrs.priceOunce = parseFloat(variationAttrs.price);
                          if (variationAttrs.on_sale) {
                            productAttrs.priceOunceSale = parseFloat(variationAttrs.sale_price);
                          }
                        }

                        if (catModel && (catModel.get('slug') == 'tanks-half-gram')) {
                            variationAttrs.isTankHalfGram = true;
                            productAttrs.priceTankHalfGram = parseFloat(variationAttrs.price);
                            if (variationAttrs.on_sale) {
                              productAttrs.priceTankHalfGramSale = parseFloat(variationAttrs.sale_price);
                            }
                        }
                        if (catModel && (catModel.get('slug') == 'tanks-gram')) {
                            variationAttrs.isTankGram = true;
                            productAttrs.priceTankGram = parseFloat(variationAttrs.price);
                            if (variationAttrs.on_sale) {
                              productAttrs.priceTankGramSale = parseFloat(variationAttrs.sale_price);
                            }
                        }
                        if (catModel && (catModel.get('slug') == 'prerolls')) {
                            variationAttrs.isPreRoll = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-one-pack')) {
                            variationAttrs.preRollSingle = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-infused')) {
                            variationAttrs.preRollInfused = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-blunt')) {
                            variationAttrs.preRollBlunt = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-two-pack')) {
                            variationAttrs.preRollMultiPackQty2 = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-three-pack')) {
                            variationAttrs.preRollMultiPackQty3 = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-four-pack')) {
                            variationAttrs.preRollMultiPackQty4 = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-five-pack')) {
                            variationAttrs.preRollMultiPackQty5 = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-ten-pack')) {
                            variationAttrs.preRollMultiPackQty10 = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-gram-joint')) {
                            variationAttrs.preRollGram = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-half-gram-joint')) {
                            variationAttrs.preRollHalfGram = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-sativa')) {
                            variationAttrs.preRollSativa = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-indica')) {
                            variationAttrs.preRollIndica = true;
                        }

                        if (catModel && (catModel.get('slug') == 'preroll-hybrid')) {
                            variationAttrs.preRollHybrid = true;
                        }

                        if (catModel && (catModel.get('slug') == '510-vaping')) {
                            variationAttrs.is510Vaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'vaping-pax-era')) {
                            variationAttrs.isEraVaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'vaping-dosist')) {
                            variationAttrs.isDosistVaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'vaping-co2')) {
                            variationAttrs.isCo2Vaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'vaping-honey-oil')) {
                            variationAttrs.isHoneyOilVaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'vaping-distillate')) {
                            variationAttrs.isDistilliteVaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'disposable')) {
                            variationAttrs.isDisposableVaping = true;
                        }
                        if (catModel && (catModel.get('slug') == 'vaping-liveresin')) {
                            variationAttrs.isLiveResinVaping = true;
                        }


                        if (catModel && (catModel.get('slug') == 'vaping-indica')) {
                            variationAttrs.isIndicaVaping = true;
                        }

                        if (catModel && (catModel.get('slug') == 'vaping-sativa')) {
                            variationAttrs.isSativaVaping = true;
                        }

                        if (catModel && (catModel.get('slug') == 'vaping-hybrid')) {
                            variationAttrs.isHybridVaping = true;
                        }

                        if (catModel && (catModel.get('slug') == 'edibles-baked')) {
                            variationAttrs.isEdiblesBaked = true;
                        }
                        if (catModel && (catModel.get('slug') == 'beverages')) {
                            variationAttrs.isEdiblesBeverages = true;
                        }
                        if (catModel && (catModel.get('slug') == 'cooking')) {
                            variationAttrs.isEdiblesCooking = true;
                        }
                        if (catModel && (catModel.get('slug') == 'candy')) {
                            variationAttrs.isEdiblesCandy = true;
                        }
                        if (catModel && (catModel.get('slug') == 'chocolate')) {
                            variationAttrs.isEdiblesChocolate = true;
                        }
                    });
                  }

                  if (productAttrs.isPreRoll && productAttrs.preRollSingle == false) {
                    productAttrs.preRollMultiPack = true;
                  }
                } // end variation in stock at location...

            });
        }

        if (productAttrs.categories) {
            _.each(productAttrs.categories, function(productCategoryAttrs) {
                var catModel = self.productCategories.findWhere({
                    slug: productCategoryAttrs.slug
                });
                if (catModel && !catModel.get('parent_id')) {
                    productAttrs.category = productCategoryAttrs.name;
                } else {
                    productAttrs.subCategory = productCategoryAttrs.name;
                }
            });
        }

        if (productAttrs.is_high_cbd == 1) {
          productAttrs.hasHighCBD = true;
        }

        if (productAttrs.is_organic == 1) {
          productAttrs.isOrganic = true;
        }

        if (productAttrs.is_high_cbn_cbg == 1 || productAttrs.is_high_cbn == 1) {
          productAttrs.hasHighCBN = true;
        }

        if (productAttrs.is_farm_exclusive == 1) {
          productAttrs.isFarmExclusive = true;
        }

        if (productAttrs.is_seasonal == 1) {
          productAttrs.isSeasonal = true;
        }

        if (productAttrs.is_sugar_free == 1) {
          productAttrs.isSugarFree = true;
        }

        if (productAttrs.is_bc_grown == 1) {
          productAttrs.isBCGrown = true;
        }
        

        self.potency_max_cbd = null;
        self.potency_max_thc = null;
        self.potency_mg_pct = null;
        self.potency_min_cbd = null;
        self.potency_min_thc = null;
        self.potency_terps = null;
        
        _.each(productAttrs.variants, function (attr) {
          _.each(attr.locations, function (location) {
            if (location.location_id === self.locationId) {
              if (location.potency_mg_pct == 'M' || location.potency_mg_pct == 'P') {
                self.potency_mg_pct = location.potency_mg_pct;
              }

              if (location.potency_terps && location.potency_terps !== null && parseFloat(location.potency_terps) > 0) {
                self.potency_terps = parseFloat(location.potency_terps);
              }

              // set min THC
              if (self.potency_min_thc == null || self.potency_min_thc == 0) {
                self.potency_min_thc = parseFloat(location.potency_min_thc);
              } else {
                // is the potency less then current min set it lower...
                if (parseFloat(location.potency_min_thc) > 0 && (self.potency_min_thc > parseFloat(location.potency_min_thc))) {
                  self.potency_min_thc = parseFloat(location.potency_min_thc);
                }
              }

              // set max THC
              if (self.potency_max_thc == null || self.potency_max_thc == 0) {
                self.potency_max_thc = parseFloat(location.potency_max_thc);
              } else {
                // is the potency more then current max set it higher...
                if (self.potency_max_thc < parseFloat(location.potency_max_thc)) {
                  self.potency_max_thc = parseFloat(location.potency_max_thc);
                }
              }

              // set min CBD
              if (self.potency_min_cbd == null || self.potency_min_cbd == 0) {
                self.potency_min_cbd = parseFloat(location.potency_min_cbd);
              } else {
                // is the potency less then current min set it lower...
                if (parseFloat(location.potency_min_cbd) > 0 && (self.potency_min_cbd > parseFloat(location.potency_min_cbd))) {
                  self.potency_min_cbd = parseFloat(location.potency_min_cbd);
                }
              }

              // set max CBD
              if (self.potency_max_cbd == null || self.potency_max_cbd == 0) {
                self.potency_max_cbd = parseFloat(location.potency_max_cbd);
              } else {
                // is the potency more then current max set it higher...
                if (self.potency_max_cbd < parseFloat(location.potency_max_cbd)) {
                  self.potency_max_cbd = parseFloat(location.potency_max_cbd);
                }
              }
            }
          });
        });

        productAttrs.potency_max_cbd = self.potency_max_cbd;
        productAttrs.potency_max_thc = self.potency_max_thc;
        productAttrs.potency_mg_pct = self.potency_mg_pct;
        productAttrs.potency_min_cbd = self.potency_min_cbd;
        productAttrs.potency_min_thc = self.potency_min_thc;
        productAttrs.potency_terps = self.potency_terps;

        if (productAttrs.potency_min_thc !== null &&
            productAttrs.potency_min_thc >= 27 &&
            productAttrs.hasHighCBD !== true) {
            productAttrs.hasHighTHC = true;
        }

        if (productAttrs.potency_max_thc !== null &&
            productAttrs.potency_max_thc !== 0 &&
            productAttrs.potency_max_thc <= 19) {
            productAttrs.hasLowTHC = true;
        }

        productAttrs.sortPrice = variantRegularPriceMin;
        productAttrs.variantRegularPriceMin = variantRegularPriceMin;
        productAttrs.variantRegularPriceMax = variantRegularPriceMax;

        productAttrs.variantSalePriceMin = variantSalePriceMin;
        productAttrs.variantSalePriceMax = variantSalePriceMax;

        productAttrs.itemName = productAttrs.title;

        if (productAttrs.description !== null && productAttrs.description !== undefined) {
          productAttrs.itemDescription = productAttrs.description.trim();
          productAttrs.itemDescriptionHtml = productAttrs.itemDescription.replace(new RegExp('\r?\n','g'), '<br />');
        }

        productAttrs.searchTitle = productAttrs.vendor_name + ' - ' + productAttrs.itemName;

        return MenuProductEntities.MenuProductModel.prototype.parse.call(this, productAttrs);
    }
});
_.extend(MenuProductModel.prototype, require('../../admin-app/entities/product-mixin'));

function isAvailableInOnlineStore () {
    return this.get('locations').find(function (productLocation) {
        return productLocation.get('type') === LocationEntities.LOCATION_TYPES.ONLINE;
    });
}

var PageableMenuProductsCollection = MenuProductEntities.PageableMenuProductsCollection.extend({
    productCategories: null,
    locationId: null,
    model: MenuProductModel,
    state: _.extend({}, MenuProductEntities.PageableMenuProductsCollection.prototype.state, {
        sortKey: 'title'
    }),
    constructor: function(models, options) {
        this.productCategories = options.productCategories;
        this.locationId = options.locationId ;
        MenuProductEntities.PageableMenuProductsCollection.prototype.constructor.call(this, models, options);
    },
    createModel: function (attrs, options) {
        return new MenuProductModel(
            attrs,
            _.defaults(
                options || {},
                {
                    productCategories: this.productCategories,
                    parse: true,
                    locationId: this.locationId
                 }
            )
        );
    }
});

var MenuProductModelLegacy = MenuProductModel.extend({
    PRODUCT_LOCATION_TYPES: LocationEntities.LOCATION_TYPES,
    isAvailableInOnlineStore: isAvailableInOnlineStore,
    parse: function (response) {
        if (response.length) {
            return MenuProductModel.prototype.parse.call(this, response[0]);
        } else {
            return MenuProductModel.prototype.parse.call(this, response);
        }
    }
});

var pageableProductsCollectionLegacyOnSaleAlphaComparator = function (model1, model2) {
    if (model1.get('on_sale') && !model2.get('on_sale')) {
        return -1;
    } else if (!model1.get('on_sale') && model2.get('on_sale')) {
        return 1;
    } else {
        var model1itemName = model1.get('itemName').toUpperCase();
        var model2itemName = model2.get('itemName').toUpperCase();
        if (model1itemName < model2itemName) {
          return -1;
        }
        if (model1itemName > model2itemName) {
          return 1;
        }
        return 0;
    }
};

var PageableMenuProductsCollectionLegacy = PageableMenuProductsCollection.extend({
    createModel: function (attrs, options) {
        return new MenuProductModelLegacy(
            attrs,
            _.defaults(
                options || {},
                {
                    productCategories: this.productCategories,
                    parse: true,
                    locationId: this.locationId
                 }
            )
        );
    }
});

module.exports = {
    PRODUCT_IMAGE_SIZES: PRODUCT_IMAGE_SIZES,
    MenuProductModel: MenuProductModel,
    PageableMenuProductsCollection: PageableMenuProductsCollection,
    MenuProductModelLegacy: MenuProductModelLegacy,
    PageableMenuProductsCollectionLegacy: PageableMenuProductsCollectionLegacy,
    pageableProductsCollectionLegacyOnSaleAlphaComparator: pageableProductsCollectionLegacyOnSaleAlphaComparator
};



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-product.js
 **/